/**
 * User-visible TICS™ brand strings (claimed / unregistered trademark).
 * Use Unicode ™ in plain text (SEO titles, footer); use TicsTitleWithTm in React for superscript + a11y.
 */

export const TICS_BRAND = 'TICS';

/** UTF-8 trademark sign (U+2122). Safe for HTML titles and footers. */
export const TICS_BRAND_WITH_TM = 'TICS™';

export const TICS_FULL_NAME = 'Training Interoperability Classification Schema';

export const TICS_FULL_NAME_WITH_TM = 'Training Interoperability Classification Schema™';

/** Phrase for aria-label / screen readers */
export const TICS_BRAND_ARIA_LABEL = 'TICS trademark';

export const TICS_TRADEMARK_ATTRIBUTION =
  'TICS™ and Training Interoperability Classification Schema™ are trademarks of American Police Training.';
